import { render, staticRenderFns } from "./SupplierSizeTextInput.vue?vue&type=template&id=cf6e958e"
import script from "./SupplierSizeTextInput.ts?vue&type=script&lang=ts&external"
export * from "./SupplierSizeTextInput.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports